import React from 'react';
import classnames from 'classnames';

import { MenuItem as MuiMenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    maxHeight: theme.spacing(5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    minHeight: theme.spacing(5),
    textDecoration: 'none',
    '&:focus, &:hover, &:active': {
      textDecoration: 'none'
    }
  },
  minWidth: {
    minWidth: 239,
    maxWidth: 239,
    width: 239
  },
  contained: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    borderRadius: theme.shape.borderRadius * 2.5
  },
  default: {
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.grey[100]
    }
  },
  primary: {
    color: theme.palette.primary.main,
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.smoke
    }
  },
  error: {
    color: theme.palette.error.main,
    '&:hover': {
      color: theme.palette.error.main,
      backgroundColor: theme.palette.error.smoke
    }
  }
}));

interface MenuItemProps {
  color?: string
  autoWidth?: boolean
  variant?: string
  className?: string
  children: React.ReactNode
  [x:string]: any
}

const MenuItem: React.FC<MenuItemProps> = React.forwardRef(({
  color,
  autoWidth,
  variant,
  className: classNameProp,
  children,
  ...otherProps
}: MenuItemProps, ref) => {
  const classes = useStyles();

  const className = classnames(
    classes.root,
    {
      [classes.default]: color === 'default',
      [classes.primary]: color === 'primary',
      [classes.error]: color === 'error',
      [classes.minWidth]: !autoWidth,
      [classes.contained]: variant === 'contained'
    },
    classNameProp
  );

  return (
    <MuiMenuItem innerRef={ref} className={className} {...otherProps}>
      {children}
    </MuiMenuItem>
  );
});

export default MenuItem;
